const PETRINE_INVITATION_ID = 'petrine-mickayla-petring-birthday';
const ADMIN_TOKEN_KEY = 'einv_admin_token';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

function getApi(path) {
  return `${API_BASE_URL}${path}`;
}

function getToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || '';
}

function toInputDateTime(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.replace(' ', 'T').slice(0, 16);
}

function createEl(tag, props = {}, children = []) {
  const el = document.createElement(tag);
  Object.entries(props).forEach(([key, value]) => {
    if (key === 'className') el.className = value;
    else if (key === 'style') Object.assign(el.style, value || {});
    else if (key === 'textContent') el.textContent = value;
    else el.setAttribute(key, value);
  });
  children.forEach((child) => el.appendChild(child));
  return el;
}

function showMessage(container, message, type = 'info') {
  if (!container) return;
  container.textContent = message || '';
  container.style.display = message ? 'block' : 'none';
  container.style.color = type === 'error' ? '#b91c1c' : '#0f766e';
  container.style.background = type === 'error' ? '#fef2f2' : '#f0fdf4';
  container.style.borderColor = type === 'error' ? '#fecaca' : '#bbf7d0';
}

function closeModal() {
  document.querySelector('[data-petrine-reminder-modal="true"]')?.remove();
}

async function openReminderModal() {
  closeModal();

  const token = getToken();
  if (!token) {
    alert('Please login to the admin dashboard first.');
    return;
  }

  const overlay = createEl('div', {
    'data-petrine-reminder-modal': 'true',
    style: {
      position: 'fixed', inset: '0', zIndex: '9999',
      background: 'rgba(26, 16, 11, .48)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '18px'
    }
  });

  const panel = createEl('div', {
    style: {
      width: 'min(100%, 560px)', maxHeight: '92vh', overflow: 'auto',
      background: '#fffaf3', borderRadius: '20px',
      border: '1px solid #eadfcd', boxShadow: '0 24px 70px rgba(0,0,0,.28)',
      padding: '22px', color: '#3d3530', fontFamily: 'Inter, Arial, sans-serif'
    }
  });

  const header = createEl('div', {
    style: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '18px' }
  });
  const titleWrap = createEl('div');
  titleWrap.appendChild(createEl('p', {
    textContent: 'Petrine Only',
    style: { margin: '0 0 4px', color: '#9a3412', fontSize: '11px', fontWeight: '800', letterSpacing: '.12em', textTransform: 'uppercase' }
  }));
  titleWrap.appendChild(createEl('h2', {
    textContent: 'Guest Email Reminder',
    style: { margin: '0', fontFamily: 'Georgia, serif', fontSize: '24px', color: '#3d3530' }
  }));
  const closeBtn = createEl('button', {
    type: 'button', textContent: '×',
    style: { width: '36px', height: '36px', borderRadius: '999px', border: '1px solid #eadfcd', background: '#fff', cursor: 'pointer', fontSize: '22px', lineHeight: '1' }
  });
  closeBtn.addEventListener('click', closeModal);
  header.appendChild(titleWrap);
  header.appendChild(closeBtn);

  const messageBox = createEl('div', {
    style: { display: 'none', border: '1px solid', borderRadius: '12px', padding: '10px 12px', marginBottom: '14px', fontSize: '13px', fontWeight: '700' }
  });

  const form = createEl('form', { style: { display: 'grid', gap: '14px' } });

  const enabledWrap = createEl('label', {
    style: { display: 'flex', alignItems: 'center', gap: '9px', fontSize: '14px', fontWeight: '800', color: '#3d3530' }
  });
  const enabledInput = createEl('input', { type: 'checkbox' });
  enabledWrap.appendChild(enabledInput);
  enabledWrap.appendChild(document.createTextNode('Enable automatic email reminder'));

  const dateField = createEl('label', { style: { display: 'grid', gap: '6px', fontSize: '12px', fontWeight: '800', color: '#7c2d12' } });
  dateField.appendChild(document.createTextNode('Reminder Date & Time'));
  const dateInput = createEl('input', {
    type: 'datetime-local',
    style: { padding: '11px 12px', borderRadius: '10px', border: '1px solid #d8c8b8', background: '#fff', color: '#3d3530' }
  });
  dateField.appendChild(dateInput);

  const subjectField = createEl('label', { style: { display: 'grid', gap: '6px', fontSize: '12px', fontWeight: '800', color: '#7c2d12' } });
  subjectField.appendChild(document.createTextNode('Email Subject'));
  const subjectInput = createEl('input', {
    type: 'text',
    style: { padding: '11px 12px', borderRadius: '10px', border: '1px solid #d8c8b8', background: '#fff', color: '#3d3530' }
  });
  subjectField.appendChild(subjectInput);

  const bodyField = createEl('label', { style: { display: 'grid', gap: '6px', fontSize: '12px', fontWeight: '800', color: '#7c2d12' } });
  bodyField.appendChild(document.createTextNode('Email Message'));
  const bodyInput = createEl('textarea', {
    rows: '8',
    style: { padding: '11px 12px', borderRadius: '10px', border: '1px solid #d8c8b8', background: '#fff', color: '#3d3530', resize: 'vertical', lineHeight: '1.5' }
  });
  bodyField.appendChild(bodyInput);

  const hint = createEl('p', {
    textContent: 'Available variables: {{name}}, {{eventDate}}, {{eventTime}}, {{venue}}, {{invitationUrl}}. Only attending guests with email addresses will receive the reminder.',
    style: { margin: '0', fontSize: '12px', color: '#8b7765', lineHeight: '1.5' }
  });

  const footer = createEl('div', { style: { display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: '10px', marginTop: '4px' } });
  const sendBtn = createEl('button', {
    type: 'button', textContent: 'Send Now', className: 'adm-btn adm-btn-secondary adm-btn-sm',
    style: { border: '1px solid #d8c8b8', borderRadius: '999px', padding: '10px 16px', background: '#fff', color: '#7c2d12', fontWeight: '800', cursor: 'pointer' }
  });
  const saveBtn = createEl('button', {
    type: 'submit', textContent: 'Save Reminder', className: 'adm-btn adm-btn-primary adm-btn-sm',
    style: { border: 'none', borderRadius: '999px', padding: '10px 18px', background: '#7c2d12', color: '#fff', fontWeight: '800', cursor: 'pointer' }
  });
  footer.appendChild(sendBtn);
  footer.appendChild(saveBtn);

  form.appendChild(enabledWrap);
  form.appendChild(dateField);
  form.appendChild(subjectField);
  form.appendChild(bodyField);
  form.appendChild(hint);
  form.appendChild(footer);

  panel.appendChild(header);
  panel.appendChild(messageBox);
  panel.appendChild(form);
  overlay.appendChild(panel);
  document.body.appendChild(overlay);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeModal();
  });

  try {
    showMessage(messageBox, 'Loading reminder settings…');
    const res = await fetch(getApi(`/admin/invitations/${PETRINE_INVITATION_ID}/reminder-settings`), {
      headers: { Authorization: `Bearer ${token}` }
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.ok) throw new Error(json.message || 'Failed to load reminder settings.');
    const settings = json.settings || {};
    enabledInput.checked = Boolean(settings.enabled);
    dateInput.value = toInputDateTime(settings.reminderAt);
    subjectInput.value = settings.subject || '';
    bodyInput.value = settings.message || '';
    showMessage(messageBox, `Eligible guests: ${settings.eligibleGuests || 0} • Sent: ${settings.sentGuests || 0}`);
  } catch (err) {
    showMessage(messageBox, err.message || 'Failed to load reminder settings.', 'error');
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    saveBtn.disabled = true;
    showMessage(messageBox, 'Saving reminder settings…');
    try {
      const res = await fetch(getApi(`/admin/invitations/${PETRINE_INVITATION_ID}/reminder-settings`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({
          enabled: enabledInput.checked,
          reminderAt: dateInput.value,
          subject: subjectInput.value,
          message: bodyInput.value
        })
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.ok) throw new Error(json.message || 'Failed to save reminder settings.');
      const settings = json.settings || {};
      showMessage(messageBox, `Saved. Eligible guests: ${settings.eligibleGuests || 0} • Sent: ${settings.sentGuests || 0}`);
    } catch (err) {
      showMessage(messageBox, err.message || 'Failed to save reminder settings.', 'error');
    } finally {
      saveBtn.disabled = false;
    }
  });

  sendBtn.addEventListener('click', async () => {
    if (!confirm('Send reminder email now to attending Petrine guests with email addresses?')) return;
    sendBtn.disabled = true;
    showMessage(messageBox, 'Sending reminders…');
    try {
      const res = await fetch(getApi(`/admin/invitations/${PETRINE_INVITATION_ID}/reminder/send-now`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({ force: true })
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.ok) throw new Error(json.message || 'Failed to send reminders.');
      showMessage(messageBox, `Done. Sent: ${json.sent || 0}. Failed: ${json.failed || 0}.`);
    } catch (err) {
      showMessage(messageBox, err.message || 'Failed to send reminders.', 'error');
    } finally {
      sendBtn.disabled = false;
    }
  });
}

function injectReminderButton() {
  if (!location.pathname.startsWith('/admin/invitations')) return;
  const rows = Array.from(document.querySelectorAll('table.adm-table tbody tr'));

  rows.forEach((row) => {
    const idCell = row.querySelector('td.adm-table-id') || row.querySelector('td:first-child');
    if (!idCell || idCell.textContent.trim() !== PETRINE_INVITATION_ID) return;
    const actions = row.querySelector('.adm-row-actions');
    if (!actions || actions.querySelector('[data-petrine-reminder-button="true"]')) return;

    const button = createEl('button', {
      type: 'button',
      className: 'adm-btn adm-btn-secondary adm-btn-sm',
      textContent: '⏰ Reminder',
      'data-petrine-reminder-button': 'true'
    });
    button.addEventListener('click', openReminderModal);
    actions.insertBefore(button, actions.firstChild);
  });
}

function startEnhancer() {
  if (window.__petrineReminderAdminEnhancerStarted) return;
  window.__petrineReminderAdminEnhancerStarted = true;

  const observer = new MutationObserver(() => injectReminderButton());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setInterval(injectReminderButton, 1500);
  injectReminderButton();
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEnhancer, { once: true });
  } else {
    startEnhancer();
  }
}
